import Navbar from 'components/navbar';
import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authServices } from 'services/authServices';
import classes from './homeScreen.module.scss';
import { homePageAnimationStringHTML } from './utils/homePageAnimationCreator';

const HomeScreen = () => {
  const navigate = useNavigate();
  const {
    UserStore: { isAuthenticated }
  } = useStore();
  const [isLoginRedirectLinkLoading, setIsLoginRedirectLinkLoading] = useState(false);

  const login = async () => {
    try {
      setIsLoginRedirectLinkLoading(true);
      const res = await authServices.initiateLogin();
      window.location = res.loginRedirectUrl as unknown as string & Location;
    } catch {
      setIsLoginRedirectLinkLoading(false);
    }
  };

  useEffect(() => {
    if (!isAuthenticated) return;
    navigate('/job-paste');
  }, [isAuthenticated, navigate]);

  return (
    <div className={classes.fdpScreenContainer}>
      {isAuthenticated ? (
        <div>
          <div className={classes.fdpScreenContainersub}>
            <div className={classes.navbar}>
              <Navbar heading={'Packaging Production Scheduling'} />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className={classes.homeScreenMenuLoginSection}>
            <div className={classes.textSection}>
              <div className={classes.title}>Packaging Production Scheduling</div>
            </div>
            <Button
              style={{
                backgroundColor: 'white',
                color: 'black',
                fontWeight: 600,
                border: 'none',
                borderRadius: '20px',
                width: '15rem',
                textAlign: 'center'
              }}
              onClick={login}
              loading={isLoginRedirectLinkLoading}
            >
              <span style={{ marginLeft: '0.5rem' }}>Click Here to Login</span>
              {!isLoginRedirectLinkLoading && (
                <img style={{ marginLeft: '1rem' }} src="homePage/images/arrow.svg" />
              )}
            </Button>
          </div>

          <iframe
            className={classes.homeScreenLoginAnimatedPage}
            srcDoc={homePageAnimationStringHTML()}
            style={{
              width: '100%',
              height: '100vh',
              border: 'none',
              overflow: 'hidden' // Prevent scrolling in the iframe itself
            }}
            title="GSMS Landing Page"
            scrolling="no" // Older method to disable scrollbars
          />
        </div>
      )}
    </div>
  );
};

export default observer(HomeScreen);
